import React from 'react';
import Icon from '../../../components/AppIcon';

const ActivityTimeline = ({ activities }) => {
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const now = new Date();
    const diffMs = now - date;
    const diffMins = Math.floor(diffMs / 60000);
    
    if (diffMins < 1) return 'Just now';
    if (diffMins < 60) return `${diffMins}m ago`;
    
    const diffHours = Math.floor(diffMins / 60);
    if (diffHours < 24) return `${diffHours}h ago`;
    
    const diffDays = Math.floor(diffHours / 24);
    return `${diffDays}d ago`;
  };

  const getActivityIcon = (action) => {
    const iconMap = {
      'admin_login': { icon: 'LogIn', color: 'text-green-600', bg: 'bg-green-100' },
      'admin_logout': { icon: 'LogOut', color: 'text-gray-600', bg: 'bg-gray-100' },
      'session_terminated': { icon: 'XCircle', color: 'text-red-600', bg: 'bg-red-100' },
      'failed_login': { icon: 'AlertTriangle', color: 'text-yellow-600', bg: 'bg-yellow-100' },
      'default': { icon: 'Activity', color: 'text-blue-600', bg: 'bg-blue-100' }
    };
    
    return iconMap?.[action] || iconMap?.['default'];
  };

  const getActivityLabel = (action) => {
    const labelMap = {
      'admin_login': 'Admin Login',
      'admin_logout': 'Admin Logout',
      'session_terminated': 'Session Terminated',
      'failed_login': 'Failed Login Attempt'
    };
    
    return labelMap?.[action] || action?.replace(/_/g, ' ')?.replace(/\b\w/g, l => l?.toUpperCase());
  };

  if (!activities || activities?.length === 0) {
    return (
      <div className="text-center py-12">
        <Icon name="Activity" className="w-12 h-12 text-gray-400 mx-auto mb-4" />
        <p className="text-gray-600">No recent activity</p>
      </div>
    );
  }

  return (
    <div className="space-y-4 max-h-96 overflow-y-auto">
      {activities?.map((activity, index) => {
        const iconConfig = getActivityIcon(activity?.action);
        
        return (
          <div key={activity?.id || index} className="flex items-start gap-4 p-4 rounded-lg hover:bg-gray-50 transition-colors">
            <div className={`w-10 h-10 ${iconConfig?.bg} rounded-lg flex items-center justify-center flex-shrink-0`}>
              <Icon name={iconConfig?.icon} className={`w-5 h-5 ${iconConfig?.color}`} />
            </div>
            <div className="flex-1 min-w-0">
              <div className="flex items-center justify-between mb-1">
                <p className="text-sm font-semibold text-gray-900">
                  {getActivityLabel(activity?.action)}
                </p>
                <span className="text-xs text-gray-500">
                  {formatDate(activity?.created_at)}
                </span>
              </div>
              <p className="text-sm text-gray-600">
                User ID: {activity?.user_id?.slice(0, 16)}...
              </p>
              {activity?.details && (
                <div className="mt-2 text-xs text-gray-500">
                  <p>IP: {activity?.ip_address || 'Unknown'}</p>
                  <p>Location: {activity?.location || 'Unknown'}</p>
                </div>
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default ActivityTimeline;